import PostUserRequestModelBase from '../_generated/modelBases/post-user-request-model-base';

export default class PostUserRequestModel extends PostUserRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
